import type { MapEdit } from './mapEdit.js';

/**
 * Saved map edits from the in-game editor. Rewritten by the dev /__mapedit
 * endpoint (see vite.config.ts). Applied to the base map in map.ts, so both the
 * client meshes and the server colliders pick them up. Empty by default.
 */
export const MAP_EDITS: MapEdit[] = [];
